import React from 'react'

interface ThreatFiltersProps {
  [key: string]: any
}

export const ThreatFilters: React.FC<ThreatFiltersProps> = (props) => {
  return (
    <div className="p-4 bg-gray-800 rounded-lg">
      <p className="text-gray-400">ThreatFilters Component - Coming Soon</p>
    </div>
  )
}
